import {
    BodyMediumRegular,
    H6Emphasized,
    MultilineInput,
    Spinner,
    XStack,
    YStack,
} from 'smoothie';

import {
    useGetFruitSlice,
    useGetFruitSliceFrame,
} from '../hooks/useFruitSlices';
import { FruitSliceHost } from './FruitSliceHost';

export const FruitSliceFramePage = ({
    sliceId,
    frameId,
}: {
    sliceId: string;
    frameId: string;
}) => {
    const { data: slice, isPending: isSlicePending } =
        useGetFruitSlice(sliceId);
    const { data: frame, isPending: isFramePending } = useGetFruitSliceFrame(
        sliceId,
        frameId,
    );

    if (isSlicePending || isFramePending) {
        return (
            <YStack flex={1} alignItems="center" justifyContent="center">
                <Spinner />
            </YStack>
        );
    }

    if (slice == null || frame == null) {
        return (
            <YStack padding="$6">
                <BodyMediumRegular>App frame not found.</BodyMediumRegular>
            </YStack>
        );
    }

    return (
        <XStack
            width="100%"
            height="calc(100vh - 120px)"
            minHeight={600}
            padding="$4"
            gap="$4"
            alignItems="stretch"
        >
            <YStack width="50%" minWidth={0} gap="$2">
                <H6Emphasized>Source</H6Emphasized>
                <MultilineInput
                    value={frame.html}
                    editable={false}
                    numberOfLines={30}
                    fontFamily="$monoBody"
                    flex={1}
                />
            </YStack>
            <YStack flex={1} minWidth={0} gap="$2">
                <H6Emphasized>Preview</H6Emphasized>
                <YStack
                    flex={1}
                    overflow="hidden"
                    borderWidth={1}
                    borderColor="$gray400"
                    borderRadius="$4"
                >
                    <FruitSliceHost slice={slice} frame={frame} />
                </YStack>
            </YStack>
        </XStack>
    );
};
